export const BLOCK_INPUT = 'input';
export const BLOCK_CALCULATION = 'calculation';

export const VARIABLE_UPDATE_EVENT = 'variable-update';
